const emailRE =
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

const mobileRE = /^[6-9]\d{9}$/;

// Supports English letters, Hindi, Marathi characters, spaces, dots, hyphens, apostrophes
const nameRE = /^[\u0900-\u097F\u0980-\u09FFa-zA-Z\s.'-]+$/;

export const VALIDATORS: Record<
    string,
    (value: string | number) => boolean | string
> = {
  EMAIL: (val: number | string) =>
      !val ? true : emailRE.test(String(val)) ? true : "Invalid email",
  MOBILE: (val: number | string) =>
      !val ? true : mobileRE.test(String(val)) ? true : "Invalid mobile number",

  NAME: (val: number | string) => {
    if (!val) return true; // Let required rule handle empty values

    const strVal = String(val).trim();

    if (strVal.length < 2) {
      return "Name must be at least 2 characters";
    }

    if (!nameRE.test(strVal)) {
      return "Only letters, spaces, and basic punctuation are allowed";
    }

    return true;
  },

};
